// extracted by mini-css-extract-plugin
export default {"container":"GoalCard_container__NWFVA","editButton":"GoalCard_editButton__28pYA","editButtons":"GoalCard_editButtons__lE1tm"};